/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { List, Collapse, ListItem, Grid, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { connect } from 'react-redux';
import IntlMessages from '../../util/IntlMessages';
import * as tools from '../../util/tools';
import useStyles from './styles';
import Comment from './comment';

function TankerFailure(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(!open);

  const getContent = (data, align = 'right') => {
    return (
      <Grid item xs={6} md={6} style={{ textAlign: align }}>
        <Typography variant="h6">{data}</Typography>
      </Grid>
    );
  };

  return (
    <Grid className={classes.root}>
      <List dense={true}>
        <ListItem>
          <Grid container spacing={5}>
            {getContent(<IntlMessages id="fuelCar" />)}
            {getContent(props.vFuelCarCode, 'left')}

            {getContent(<IntlMessages id="kilometer" />)}
            {getContent(tools.numberformat(props.iKilometer), 'left')}

            {getContent(<IntlMessages id="date" />)}
            {getContent(tools.miladiTojalali(props.dtDate.dtRequestRepairAt), 'left')}

            {getContent(<IntlMessages id="status" />)}
            {getContent(tools.getFuelCarRepairStatus(props.iStatus), 'left')}
          </Grid>
        </ListItem>
        <ListItem onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Comment {...props} />
        </Collapse>
      </List>
    </Grid>
  );
}

export default connect()(TankerFailure);
